import {point} from '@turf/helpers';

import transform from './transform';

export default coordinate => point(transform(coordinate));
